export type MinimizedViewField =
  | "title"
  | "tags"
  | "value"
  | "closeDate"
  | "contacts"
  | "assignee"
  | "inactivity";

export type MinimizedViewConfig = Record<MinimizedViewField, boolean>;

export const DEFAULT_MINIMIZED_VIEW: MinimizedViewConfig = {
  title: true,
  tags: false,
  value: false,
  closeDate: false,
  contacts: false,
  assignee: false,
  inactivity: false,
};

const storageKey = (boardId: string, listId: string) =>
  `wembii.crm.minimizedView.${boardId}.${listId}`;

export const loadMinimizedViewConfig = (
  boardId: string,
  listId: string
): MinimizedViewConfig => {
  try {
    const raw = localStorage.getItem(storageKey(boardId, listId));
    if (!raw) return { ...DEFAULT_MINIMIZED_VIEW };
    const parsed = JSON.parse(raw) as Partial<MinimizedViewConfig>;
    return {
      ...DEFAULT_MINIMIZED_VIEW,
      ...parsed,
      title: true,
    };
  } catch {
    return { ...DEFAULT_MINIMIZED_VIEW };
  }
};

export const saveMinimizedViewConfig = (
  boardId: string,
  listId: string,
  config: MinimizedViewConfig
) => {
  try {
    localStorage.setItem(
      storageKey(boardId, listId),
      JSON.stringify({ ...config, title: true })
    );
  } catch {
    // ignore quota / private mode
  }
};
